let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9i3Cs")).then(() => parcelRequire('gbpRj'));